document.addEventListener("turbolinks:load", function() {
  const currentPath = window.location.pathname;

let dotInterval;
if (currentPath === '/reports/who') {
  document.getElementById("download-btn").addEventListener("click", function () {
    const startDateStr = document.getElementById("start-date").value;
    const endDateStr = document.getElementById("end-date").value;

    if (!startDateStr || !endDateStr) {
      alert("開始日と終了日を入力してください");
      return;
    }

    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    const today = new Date();

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      alert("日付の形式が正しくありません");
      return;
    }

    if (startDate > endDate) {
      alert("開始日は終了日以前の日付を指定してください");
      return;
    }

    if (endDate > today) {
      alert("終了日は未来の日付にできません");
      return;
    }

    const mainContents = document.querySelector('.main-contents-body');
    const oldestDateStr = mainContents?.dataset.oldestDate;

    if (oldestDateStr) {
      const oldestDate = new Date(oldestDateStr.replace(/-/g, "/"));
      if (startDate < oldestDate) {
        alert(`開始日はデータの存在する最古の日付（${oldestDateStr}）以降を指定してください`);
        return;
      }
    }

    startLoading();

    fetch(`/reports/create_async?start_date=${startDateStr}&end_date=${endDateStr}`, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'application/json'
      }
    })
    .then(response => {
      // ステータスコードが 200-299 以外の場合（400系, 500系エラー）
      if (!response.ok) {
        throw new Error("Server Error"); // .catch へ飛ばす
      }
      return response.json();
    })
    .then(data => {
      // 成功時の処理
      document.getElementById("input-area").style.display = "none";
      document.getElementById("completion-message").style.display = "block";
    })
    .catch((error) => {
      alert("リクエストの送信に失敗しました。もう一度お試しください。");
      console.error("Download error:", error);
    })
    .finally(() => {
      stopLoading();
    });
  });
}

function startLoading() {
  document.getElementById("download-btn").disabled = true;
}

function stopLoading() {
  document.getElementById("download-btn").disabled = false;
}

});
